import * as requestFromServer from "./productsCrud";
import {
	setProducts, setSelectedProduct
} from "./productsSlice";
import {
	setErrorTypeAction
} from "../errors/errorsActions";



export const GetAllProducts = (t) => (dispatch, getState) => {
	const customer = getState().customer.selectedCustomer;
	return requestFromServer
		.getProducts(customer)
		.then((response) => {
			dispatch(setProducts(response));
		})
		.catch((error) => {
			dispatch(setErrorTypeAction(t("sg.msg.errorLoadProd")));
		});
};

export const SelectProductAction = (product) => (dispatch) => {
		dispatch(setSelectedProduct(product));
};

